export enum OnyxOverlayPosition {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT,
}
